import * as React from 'react';
import cx from 'classnames';
import { CartResponse } from '../../models/cart';
import { Router } from '../../configs/routes';
import schedulePaymentStyles from './../../styles/paymentSchedule/schedulePayment.scss';
import { Api } from '../../api';
import { Direction, MONTH_TEXT_MAP } from './../../constants';
import { getNextMonthDate, getNextThirtyDays } from './../../utils';
import { trackAction } from './../../utils/trackActions';
// import { showError } from '../../utils';
// import { handleTrack } from '../../utils/trackActions';

const api = new Api();
const { Fragment } = React;

const MAP_ORDER_TYPE = {
  SIP_MF: 'SIP_MF_ORDER_ITEM',
  LUMPSUM_MF: 'LUMPSUM_MF_ORDER_ITEM',
};

const MONTH_SHORT_TEXT = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};
interface Props {
  cart?: CartResponse;
  selectedBankAccId: number;
  userBankAccounts: any;
  updateBankId: (val: number, cb: Function) => void;
  sipDates: string[];
  investmentType: Direction;
  dissmissScheduleModal?: () => void;
  dismissModal: () => void;
}

interface State {
  scheduled: boolean;
  failure: boolean;
  selectedSipDate: string;
  mandateId: string;
  selectedLumpsumDate: string;
  availableLumpsumDates: string[];
  mandateErr: boolean;
}

class ScheduleLater extends React.Component<Props, State> {
  public state: State = {
    scheduled: false,
    failure: false,
    selectedSipDate: '05',
    mandateId: '',
    selectedLumpsumDate: '',
    availableLumpsumDates: [],
    mandateErr: false,
  };

  private setMandateStatus = async () => {
    const { selectedBankAccId, cart } = this.props;
    const res = await api.getMandateStatus(cart.totalAmount, selectedBankAccId);
    if (res && res.status !== 404) {
      const { externalId } = res;
      this.setState({
        mandateId: externalId,
        mandateErr: false,
      });
    } else {
      this.setState({
        mandateErr: true,
      });
    }
  };
  public componentDidMount() {
    this.setMandateStatus();
    this.setScheduleDate();
  }

  private setScheduleDate = () => {
    const { investmentType } = this.props;
    if (investmentType === Direction.SIP) {
      const nearestSIPDate = this.getNearestSIPDate();
      this.setState({
        selectedSipDate: nearestSIPDate,
      });
    } else {
      const nearestLumpsumDate = this.getAvailableLumpsumDate().slice(3)[0];
      this.setState({
        selectedLumpsumDate: nearestLumpsumDate,
        availableLumpsumDates: this.getAvailableLumpsumDate().slice(3),
      });
    }
  };

  private getNearestSIPDate = (): string => {
    const today = new Date().getDate();
    if (today < 7) {
      return '05';
    } else if (today > 16) {
      return '20';
    } else {
      return '10';
    }
  };

  private handleBankChange(
    evt: React.FormEvent<HTMLSelectElement>,
    fn: Function
  ) {
    const { value } = evt.target;
    if (value === 'addNew') {
      Router.push(`/save/profile?modal=addBank`); // Facing issue in pushRoute, so used push
      return;
    }
    if (value) {
      fn(Number(value), this.setMandateStatus);
    }
  }

  private onViewDashboard = () => {
    Router.pushRoute(`/save/dashboard/portfolio`);
  };

  private scheduleSuccess = () => {
    return (
      <div
        className={cx(
          schedulePaymentStyles['align-item-center'],
          'columns lil-flex lil-flex-col lil-justify-center'
        )}
      >
        <img src="https://assets1.cleartax-cdn.com/clearsave/images/1645708220_shape.svg" />
        <p className="lil-text-s-24 lil-font-bold lil-mt-4 lil-text-black">
          Your order is scheduled
        </p>
        <button
          className="btn btn-blue lil-mt-4 lil-btn-blue"
          onClick={this.onViewDashboard}
        >
          View in dashboard
        </button>
      </div>
    );
  };

  private failureModal = () => {
    const { dissmissScheduleModal, dismissModal } = this.props;
    return (
      <div
        className={cx(
          schedulePaymentStyles['align-item-center'],
          'columns lil-flex lil-flex-col lil-justify-center'
        )}
      >
        <img src="https://assets1.cleartax-cdn.com/clearsave/images/1645709473_group18142027.svg" />
        <p className="lil-text-s-24 lil-font-bold lil-mt-4 lil-text-black">
          Oops! Transaction failed!{' '}
        </p>
        <p className="lil-text-s-14 lil-mt-4">
          It can be due to bank account mismatch. Please transact from the bank
          account ending with XXXX. Alternatively you can try a different
          payment method.
        </p>
        <div className="lil-flex lil-mt-4 lil-w-full lil-justify-evenly">
          <button
            className="btn btn-blue lil-btn-blue"
            onClick={dissmissScheduleModal}
          >
            Re-try payment
          </button>
          <button className="btn btn-blue" onClick={dismissModal}>
            Go back
          </button>
        </div>
        {/* <a href="#" className="lil-mt-2 lil-text-blue-400 lil-font-bold">
          Contact Support
        </a> */}
      </div>
    );
  };

  private getPrevDate = () => {
    const {
      selectedLumpsumDate,
      selectedSipDate,
      availableLumpsumDates,
    } = this.state;
    const { investmentType, sipDates } = this.props;
    if (Direction.SIP === investmentType) {
      this.setState({
        selectedSipDate: sipDates[sipDates.indexOf(selectedSipDate) - 1],
      });
    } else {
      const currIndex = availableLumpsumDates.indexOf(selectedLumpsumDate);
      this.setState({
        selectedLumpsumDate: availableLumpsumDates[currIndex - 1],
      });
    }
  };
  private getNextDate = () => {
    const {
      selectedLumpsumDate,
      selectedSipDate,
      availableLumpsumDates,
    } = this.state;
    const { investmentType, sipDates } = this.props;
    if (Direction.SIP === investmentType) {
      this.setState({
        selectedSipDate: sipDates[sipDates.indexOf(selectedSipDate) + 1],
      });
    } else {
      const currIndex = availableLumpsumDates.indexOf(selectedLumpsumDate);
      this.setState({
        selectedLumpsumDate: availableLumpsumDates[currIndex + 1],
      });
    }
  };

  private getAvailableLumpsumDate = () => {
    const today = new Date();

    const year = today.getFullYear();
    const month = today.getMonth();
    const day = today.getDate();
    const date = `${month + 1}/${day}/${year}`;

    const nextThirtyDays = getNextThirtyDays(date);
    return nextThirtyDays.map(
      item =>
        new Date(item).getDate() +
        ' ' +
        MONTH_SHORT_TEXT[new Date(item).getMonth() + 1] +
        ' ' +
        new Date(item).getFullYear()
    );
  };

  private NormalizeDate(num: string | number) {
    if (Number(num) < 10) {
      return `0${Number(num)}`;
    }
    return String(num);
  }
  private scheduleOrder = async () => {
    const { mandateId, selectedLumpsumDate, selectedSipDate } = this.state;
    const { cart, investmentType } = this.props;
    const isSip = Direction.SIP === investmentType;
    // For Lumpsum
    const firstInstallmentDay = selectedLumpsumDate.split(' ')[0];
    const firstInstallmentMonth = Object.keys(MONTH_SHORT_TEXT).find(
      key => MONTH_SHORT_TEXT[key] === selectedLumpsumDate.split(' ')[1]
    );
    const firstInstallmentYr = selectedLumpsumDate.split(' ')[2];

    const firstInstallmentDateForLumpsum =
      firstInstallmentYr +
      '-' +
      this.NormalizeDate(firstInstallmentMonth) +
      '-' +
      this.NormalizeDate(firstInstallmentDay);

    // For SIP
    const scheduleMonth =
      new Date().getDate() + 2 < Number(selectedSipDate)
        ? new Date().getMonth() + 1
        : new Date().getMonth() + 2;
    const firstInstallmentDateForSip = `${new Date().getFullYear()}-${this.NormalizeDate(
      scheduleMonth
    )}-${this.NormalizeDate(selectedSipDate)}`;
    const nextDate = getNextMonthDate(firstInstallmentDateForSip);
    const nextSipDate = `${nextDate.getFullYear()}-${this.NormalizeDate(
      nextDate.getMonth() + 1
    )}-${this.NormalizeDate(nextDate.getDate())}`;

    const firstInstallmentDate = isSip
      ? firstInstallmentDateForSip
      : firstInstallmentDateForLumpsum;
    const sipDate = isSip ? nextSipDate : firstInstallmentDateForLumpsum;
    if (cart) {
      //   const { item } = cart;
      const orderType = MAP_ORDER_TYPE[investmentType];
      //   const sipDate =
      const requestedObj = {
        firstInstallmentDate,
        sipDate,
        orderType,
        paymentProvider: 'DIRECT_MANDATE',
        orderOwnerCode: 'SELF',
        mandateId,
      };
      trackAction('schedule-later-initiate', 'schedule-later');
      const res = await api.schedulePayment(requestedObj);
      const { success } = res || {};
      if (!success) {
        this.setState({
          failure: true,
        });
      } else {
        trackAction('schedule-success', 'schedule-later');
        this.setState({
          scheduled: true,
        });
      }
    }
  };

  public render() {
    const {
      scheduled,
      selectedSipDate,
      selectedLumpsumDate,
      availableLumpsumDates,
      failure,
      mandateErr,
    } = this.state;
    const {
      cart,
      selectedBankAccId,
      userBankAccounts,
      updateBankId,
      investmentType,
      sipDates,
    } = this.props;
    const isSip = Direction.SIP === investmentType;
    const scheduleMonth =
      new Date().getDate() + 2 < Number(selectedSipDate)
        ? MONTH_TEXT_MAP[new Date().getMonth() + 1]
        : MONTH_TEXT_MAP[new Date().getMonth() + 2];
    const selectedDate = isSip
      ? selectedSipDate + ' ' + scheduleMonth
      : selectedLumpsumDate;
    return (
      <div>
        {scheduled ? (
          this.scheduleSuccess()
        ) : failure ? (
          this.failureModal()
        ) : (
          <Fragment>
            <div
              className={cx(
                schedulePaymentStyles['align-item-center'],
                'lil-flex columns'
              )}
            >
              <div className="lil-w-1/3">
                <div className="lil-text-s-12">Amount</div>
                <div className="lil-font-black lil-font-bold lil-mt-2 lil-text-s-24">
                  ₹ {cart.totalAmount.toLocaleString('en-IN')}
                </div>
              </div>
              <div>
                <span className="lil-text-s-12">Selected bank for payment</span>
                <select
                  className={cx(
                    schedulePaymentStyles['select-dd'],
                    'form-control mt10'
                  )}
                  value={selectedBankAccId}
                  onChange={e => this.handleBankChange(e, updateBankId)}
                >
                  {userBankAccounts &&
                    userBankAccounts.map(item => (
                      <option value={item.id} key={item.id}>
                        {/* <img src={item.bankLogoUrl || ''} width="40px" height="40px"/> */}
                        {item.nameOfBank || ''}
                      </option>
                    ))}

                  <option value={'addNew'}> + Add new</option>
                </select>
              </div>
            </div>
            <div className="columns lil-border-grey-400 lil-border-t-sm lil-mt-5" />
            <div
              className={cx(
                schedulePaymentStyles['align-item-center'],
                'columns lil-flex lil-mt-5'
              )}
            >
              <div className="lil-w-1/2 lil-font-bold">
                Select investment date
              </div>
              <div
                className={cx(
                  schedulePaymentStyles['align-item-center'],
                  'lil-flex lil-w-1/2 lil-overflow-auto'
                )}
              >
                {(!isSip && availableLumpsumDates[0] !== selectedLumpsumDate) ||
                (isSip && selectedSipDate !== '05') ? (
                  <img
                    src="https://assets1.cleartax-cdn.com/clearsave/images/1645695224_shape.svg"
                    className={cx(
                      schedulePaymentStyles['carrousel-arrow'],
                      'lil-mr-2 lil-cursor-pointer'
                    )}
                    onClick={this.getPrevDate}
                  />
                ) : null}
                {isSip
                  ? sipDates.map(item => (
                      <span
                        className={cx(
                          {
                            [schedulePaymentStyles['selcted-date']]:
                              Number(selectedSipDate) === Number(item),
                          },
                          'lil-ml-2 lil-mr-2'
                        )}
                      >
                        {item}
                      </span>
                    ))
                  : availableLumpsumDates &&
                    availableLumpsumDates.map(item => {
                      return (
                        <span
                          className={cx(
                            {
                              ['hidden']:
                                selectedLumpsumDate !== item &&
                                availableLumpsumDates[
                                  availableLumpsumDates.indexOf(
                                    selectedLumpsumDate
                                  ) - 1
                                ] !== item &&
                                availableLumpsumDates[
                                  availableLumpsumDates.indexOf(
                                    selectedLumpsumDate
                                  ) + 1
                                ] !== item,
                            },
                            {
                              [schedulePaymentStyles['selcted-date']]:
                                selectedLumpsumDate === item,
                              ['lil-text-s-14']: selectedLumpsumDate === item,
                            },
                            'lil-ml-2 lil-mr-2 lil-text-s-10'
                          )}
                        >
                          {item.slice(0, -4)}
                        </span>
                      );
                    })}

                {(!isSip &&
                  selectedLumpsumDate !==
                    availableLumpsumDates[availableLumpsumDates.length - 1]) ||
                (isSip && selectedSipDate !== '20') ? (
                  <img
                    src="https://assets1.cleartax-cdn.com/clearsave/images/1645695314_shape.svg"
                    className={cx(
                      schedulePaymentStyles['carrousel-arrow'],
                      'lil-ml-2 lil-cursor-pointer'
                    )}
                    onClick={this.getNextDate}
                  />
                ) : null}
              </div>
            </div>
            <p className="lil-mt-5 lil-text-s-14 columns">
              We will debit ₹{cart.totalAmount.toLocaleString('en-IN')} from
              your bank two days before the investment date and place the order
              from {selectedDate}.
            </p>
            {mandateErr && (
              <p className="lil-mt-5 lil-text-s-14 columns lil-text-red">
                {' '}
                Your Investment amount is greater than your mandate amount.
                Kindly{' '}
                <a href="/save/mandate/" className="lil-underline">
                  setup your mandate
                </a>{' '}
                to schedule this order
              </p>
            )}
            <div className="lil-flex lil-justify-center columns lil-mt-5">
              <button
                className={cx('lil-btn lil-btn-blue lil-mr-4 m-nostyle', {
                  ['disable']: mandateErr,
                })}
                onClick={this.scheduleOrder}
                disabled={mandateErr}
              >
                Confirm order
              </button>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

export default ScheduleLater;



// WEBPACK FOOTER //
// ./components/common/scheduleLater.tsx